import { loadScript } from '@superbet-group/web.lib.utilities';
import { ShellLocalConfig } from '@src/config/shell/localConfigTypes';

// Avoids calling amplitude.init more than once
let isScriptStarted = false;

/**
 * Not a critical script. If it doesn't load, silently pass
 */
export async function loadAmplitudeSdk({
    isEnabled,
    apiKey,
    userUuid,
    serverZone,
}: {
    isEnabled: boolean;
    apiKey: string;
    userUuid: string;
    serverZone: ShellLocalConfig['amplitudeServerZone'];
}): Promise<void> {
    if (!isEnabled || !apiKey || isScriptStarted) {
        return;
    }
    isScriptStarted = true;
    await loadScript(`https://cdn.eu.amplitude.com/script/${apiKey}.js`, 'amplitudeSdk');
    (window as any).amplitude.init(apiKey, userUuid, {
        fetchRemoteConfig: true,
        autocapture: {
            attribution: true,
            pageViews: true,
            sessions: true,
            formInteractions: false,
            fileDownloads: false,
            elementInteractions: true,
        },
        serverZone: serverZone,
    });
}
